import React, { useEffect, useState } from 'react';
import formulaService from '../../../../services/formulaService';

export const FormulaImpactModal = ({ formula, onClose }) => {
  const [impactData, setImpactData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (formula?.formulaId) {
      setLoading(true);
      formulaService.getImpactAnalysis(formula.formulaId, formula.targetObsId)
        .then(data => setImpactData(data))
        .catch(err => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [formula]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content-lg" onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '18px', color: '#0f172a' }}>
              Impact & Dependency Graph: {formula?.formulaName}
            </h2>
            <span style={{ fontSize: '13px', color: '#64748b' }}>
              Code: {formula?.formulaCode} | Target Obs #{formula?.targetObsId}
            </span>
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#64748b' }}
          >
            ✕
          </button>
        </div>

        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
            Evaluating dependency tree and downstream impact...
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {/* Impact Banner */}
            <div style={{
              background: impactData?.dependentFormulas?.length > 0 ? '#fff7ed' : '#f0fdf4',
              border: `1px solid ${impactData?.dependentFormulas?.length > 0 ? '#fed7aa' : '#bbf7d0'}`,
              color: impactData?.dependentFormulas?.length > 0 ? '#9a3412' : '#166534',
              padding: '16px',
              borderRadius: '12px',
              fontSize: '13.5px'
            }}>
              <strong>Clinical Impact Summary:</strong>
              <div>{impactData?.warningMessage}</div>
            </div>

            {/* Downstream Dependent Formulas */}
            <div>
              <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#1e293b' }}>
                Downstream Formulas (Consume Output of this Observation)
              </h4>
              {impactData?.dependentFormulas?.length === 0 ? (
                <div style={{ padding: '16px', background: '#f8fafc', borderRadius: '8px', color: '#64748b', fontSize: '13px' }}>
                  No other formulas currently depend on this output. Safe to modify or adjust without cascade effects.
                </div>
              ) : (
                <div style={{ border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden' }}>
                  <table className="formula-table">
                    <thead>
                      <tr>
                        <th>Dependent Formula</th>
                        <th>Code</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {impactData?.dependentFormulas?.map(dep => (
                        <tr key={dep.dependentFormulaId}>
                          <td style={{ fontWeight: 600 }}>{dep.dependentFormulaName}</td>
                          <td><span className="formula-code-badge">{dep.dependentFormulaCode}</span></td>
                          <td>
                            <span className={`status-badge status-${(dep.status || 'draft').toLowerCase()}`}>
                              {dep.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Affected Investigations Count */}
            <div style={{ display: 'flex', gap: '16px' }}>
              <div className="stat-card" style={{ flex: 1 }}>
                <span className="stat-card-label">Investigations Impacted</span>
                <span className="stat-card-value">{impactData?.affectedInvestigations || 0}</span>
              </div>
              <div className="stat-card" style={{ flex: 1 }}>
                <span className="stat-card-label">Cascade Formulas</span>
                <span className="stat-card-value">{impactData?.dependentFormulas?.length || 0}</span>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
              <button className="btn-primary-gradient" onClick={onClose}>
                Close Analysis
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormulaImpactModal;
